export default __webpack_public_path__ + "static/media/cog.ba51bb95.svg";